// Exact deadlines in the restaurant's own time zone (admin review 2026-11-02): "4 noiembrie, 14:12", never only
// "mai ai 37 de ore" — the owner plans the day by the clock of the restaurant, not of the phone.

export function formatDeadline(ms: number, timeZone: string): string {
  const parts = new Intl.DateTimeFormat("ro-RO", {
    timeZone,
    day: "numeric",
    month: "long",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date(ms));
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? "";
  return `${get("day")} ${get("month")}, ${get("hour")}:${get("minute")}`;
}

/** "în 37 de ore" / "în 2 zile" — the time left, next to the exact deadline. */
export function timeLeft(ms: number, now: number): string {
  const hours = Math.max(1, Math.ceil((ms - now) / 3_600_000));
  if (hours < 48) return hours === 1 ? "într-o oră" : `în ${hours}${hours >= 20 ? " de" : ""} ore`;
  const days = Math.floor(hours / 24);
  return `în ${days} zile`;
}
